var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-light mr-4",attrs:{"href":"https://hub.respondeco.org/meetings/jan-draxler","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('header.contact_respondeco'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }